import { apiGet, apiPost } from '../standardApi';

export async function apiSendMedicalCare(body) {
  const response = await apiPost(
    '/Contacts/SendMedicalCare',
    body,
    '',
    'form-data'
  );
  return response;
}

export async function apiSendContact(body) {
  const response = await apiPost(
    '/Contacts/sendquestions',
    body,
    '',
    'form-data'
  );
  return response;
}

export async function apiFaqDemandsQuestions() {

  const response = await apiGet('/contacts/GetFaqDemandsQuestions');
  return response;
}
export async function apiGetClientDemands(
  skip,
  top,
  search,
  orderBy,
  direction
) {
  let query = '';
  if (search) {
    query += `&Search=${search}`;
  }
  if (orderBy) {
    query += `&OrderBy=${orderBy}`;
  }
  if (direction) {
    query += `&Direction=${direction}`;
  }
  const response = await apiGet(
    `/Contacts/GetClientDemands?Skip=${skip}&Top=${top}` + query
  );
  return response;
}
export async function apiSendResponseDemand(demandeId, body) {
  const response = await apiPost(
    `/Contacts/SendResponseDemand/${demandeId}`,
    body,
    'application/json',
    'application/json'
  );
  return response;
}

export async function apiDownloadDocument(documentId) {
  const response = await apiGet(
    `/Documents/GetSpVieDocument/` + documentId
  );
  return response;
}

export async function apiSendMedicalCareDemand(body) {
  const response = await apiPost(
    `/Contact/SendMedicalCareDemand`,
    body,
    'application/json',
    'application/json'
  );
  return response;
}